import React from 'react'
import { Routes, Route } from 'react-router-dom'
import routes from 'routes'
import useUser from 'commons/hooks/useUser'
import PopupSnackbar from 'components/Snackbar'
import Modal from 'components/Modal'
import AppRoute from './AppRoute'
import { MainContainer } from './styles'

function Main() {
  const { user, hasPermission } = useUser()

  return (
    <MainContainer>
      <Routes>
        {routes.map(route => (
          <Route
            {...route}
            key={route.path}
            element={<AppRoute loggedIn={user.authenticated} hasPermission={hasPermission} {...route} />}
          />
        ))}
      </Routes>
      <PopupSnackbar />
      <Modal />
    </MainContainer>
  )
}

export default Main
